import { render } from "./FeatureLevelPermission.vue?vue&type=template&id=4bfb980c"
import script from "./FeatureLevelPermission.vue?vue&type=script&lang=js"
export * from "./FeatureLevelPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__